<template>
  <div class="modal-overlay" @click.self="close">
    <div class="">
      <form @submit.prevent="handleDelete" class="delete-modal">
        <header class="delete-modal-header">
          <h2 class="delete-modal-title">Verwijder BV</h2>
          <button
              type="button"
              class="close-button"
              @click="close()"
              aria-label="Sluiten"
          >
            <span class="close-icon" aria-hidden="true"></span>
          </button>
        </header>

        <p class="delete-modal-message">
          Als u dit verwijdert, kan het niet worden teruggedraaid. Weet u zeker dat u dit wilt verwijderen?
        </p>

        <footer class="delete-modal-actions">
          <button
              type="button"
              class="cancel-button"
              @click="close()"
          >
            Annuleren
          </button>
          <button
              type="submit"
              class="delete-button"
          >
            Verwijderen
          </button>
        </footer>
      </form>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineEmits, type PropType} from 'vue'
import type {BvUser} from "../components/types";

const emit = defineEmits(['close','delete']);
const close = () => {
  emit('close');
};
const props = defineProps({
  user: {
    type: Object as PropType<BvUser>,
    required: true
  }
});
const handleDelete = () => {
  emit('delete',props.user!.id!)
  close();

}
</script>

<style scoped>

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  width: 400px;
  border-radius: 8px;
  position: relative;
}
.delete-modal {
  border-radius: 20px;
  background: var(--Neutral-background, #f7f8fc);
  display: flex;
  max-width: 406px;
  flex-direction: column;
  padding: 16px;
  font: 14px Montserrat, sans-serif;
}

.delete-modal-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  color: var(--Neutral-5, #191a1f);
}

.delete-modal-title {
  font-weight: 500;
  line-height: 1;
  margin: 0;
}

.close-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-icon {
  width: 24px;
  height: 24px;
  background-image: url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 6L18 18M6 18L18 6" stroke="currentColor" stroke-width="2"/></svg>');
}

.delete-modal-message {
  color: var(--Neutral-5, #191a1f);
  text-align: center;
  font-weight: 400;
  line-height: 20px;
  margin: 32px 0;
}

.delete-modal-actions {
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 32px;
}

.cancel-button,
.delete-button {
  flex: 1;
  border-radius: 8px;
  min-height: 40px;
  font-weight: 700;
  line-height: 24px;
  padding: 8px 12px;
  border: none;
  cursor: pointer;
}

.cancel-button {
  background: var(--Primary-Primary, #080aed);
  color: var(--Neutral-1, #fcfcfc);
}

.delete-button {
  background: transparent;
  color: var(--red-3, #e51a1a);
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>